import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { ConfirmDialog } from '../PrototypeShared';
import { usePrototypeAuth } from '../PrototypeAuthContext';

export default function OperatorLoginScreen() {
  const navigate = useNavigate();
  const { login } = usePrototypeAuth();
  const [pin, setPin] = useState('');
  const [errorModal, setErrorModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pin.length < 4) {
      setErrorModal(true);
      return;
    }
    login();
    navigate('/prototype/operator');
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Operator login</Typography>
        <Typography color="text.secondary" paragraph>Prototype: enter any 4+ digit PIN to continue to Operator app.</Typography>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="PIN" type="password" value={pin} onChange={(e) => setPin(e.target.value)} margin="normal" inputProps={{ inputMode: 'numeric' }} />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>Enter</Button>
        </form>
        <Button component={Link} to="/prototype/login" size="small" sx={{ mt: 2 }}>Back to main login</Button>
      </Paper>
      <ConfirmDialog open={errorModal} title="Invalid PIN" message="Please enter at least 4 digits." onConfirm={() => setErrorModal(false)} onCancel={() => setErrorModal(false)} confirmLabel="OK" />
    </Box>
  );
}
